import DataPool from './datapool';
import Fields from './fields';
import Org from './org';
import Tokenizer from './tokenizer';
import TrainingRevision from './trainingRevision';
import TrainingSet from './trainingSet';
import Wrapper from './wrapper';
import ExtractionBatch from './extractionBatch';
import Extraction from './extraction';
import Document from './document';
import GroundTruth from './groundTruth';
import Correction from './correction';
import Tokenized from './tokenized';
import DataTypes from './dataTypes';
import DataExports from './dataExports';
import Packager from './packager';
import Packages from './packages';
import DocumentData from './documentData';
import Vendor from './vendor';
import Client from './client';
import Language from './language';
import MAT from './mat';
import Ruleset from './ruleset';

/**
 * Get an instance of the Glynt library
 * @class
 * @param {string} token Auth0's token.
 * @returns {Glynt} Instance of this library
 */
class Glynt {
  fields: Fields;
  trainingSet: TrainingSet;
  trainingRevision: TrainingRevision;
  dataPool: DataPool;
  dataTypes: DataTypes;
  org: Org;
  tokenizer: Tokenizer;
  extractionBatch: ExtractionBatch;
  extraction: Extraction;
  document: Document;
  correction: Correction;
  groundTruths: GroundTruth;
  tokenizeds: Tokenized;
  dataExports: DataExports;
  packager: Packager;
  packages: Packages;
  documentData: DocumentData;
  vendor: Vendor;
  clientApi: Client;
  language: Language;
  mat: MAT;
  ruleset: Ruleset;

  constructor(token: string, dataPoolId: string) {
    const wrapper = new Wrapper(token, dataPoolId);
    this.dataPool = new DataPool(wrapper);
    this.dataTypes = new DataTypes(wrapper);
    this.org = new Org(wrapper);
    this.fields = new Fields(wrapper);
    this.trainingSet = new TrainingSet(wrapper);
    this.trainingRevision = new TrainingRevision(wrapper);
    this.tokenizer = new Tokenizer(wrapper);
    this.extractionBatch = new ExtractionBatch(wrapper);
    this.document = new Document(wrapper);
    this.extraction = new Extraction(wrapper);
    this.groundTruths = new GroundTruth(wrapper);
    this.correction = new Correction(wrapper);
    this.tokenizeds = new Tokenized(wrapper);
    this.dataExports = new DataExports(wrapper);
    this.packager = new Packager(wrapper);
    this.packages = new Packages(wrapper);
    this.documentData = new DocumentData(wrapper);
    this.vendor = new Vendor(wrapper);
    this.clientApi = new Client(wrapper);
    this.language = new Language(wrapper);
    this.mat = new MAT(wrapper);
    this.ruleset = new Ruleset(wrapper);
  }
}

export default Glynt;
